module.exports = __webpack_public_path__ + "images/howtouse/howto-functions03_45bb7036f4d94e99bde1478af1ace521.png";